import React from 'react';
import styles from './suggestion-item.module.scss';
import { PiError } from 'features/pi/model/pi-errors/PiError';

type SuggestionItemProps = {
    text: string;
    input?: string;
    onClick: () => void;
};

export const SuggestionItem: React.FC<SuggestionItemProps> = ({ text, input, onClick }) => {
    const highlightedText = () => {
        if (!input) return text;

        const words = input.split(/\s+/).filter(Boolean); // Split by spaces and remove empty strings
        const escapedWords = words.map(word =>
            word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
        );
        let regex;
        try {
            regex = new RegExp(`\\b(${escapedWords.join('|')})\\b`, 'i');
        } catch (error) {
            console.error(new PiError('Error with suggestionItem regex', { cause: error as Error }));
            return '';
        }

        const parts = text.split(regex);
        return parts.map((part, index) =>
            words.some((word) => word.toLowerCase() === part.toLowerCase()) ? (
                <span key={index} className={styles.inputText}>
                    {part}
                </span>
            ) : (
                <b key={index}>{part}</b>
            ),
        );
    };

    return (
        <div onClick={onClick} className={styles.container}>
            {highlightedText()}
        </div>
    );
};
